import { analytics, VersionEvents } from '@/lib/analytics'
import { APP_BUILD_ID } from '@/lib/version'

interface UpdateDialogEventData {
  remoteVersion?: string
}

export function trackUpdateDialogShown(data?: UpdateDialogEventData): void {
  analytics.track(VersionEvents.UPDATE_DIALOG_SHOWN, {
    local_version: APP_BUILD_ID,
    remote_version: data?.remoteVersion,
  })
}

export function trackUpdateDialogAccepted(): void {
  analytics.track(VersionEvents.UPDATE_DIALOG_ACCEPTED, {
    local_version: APP_BUILD_ID,
  })
}

export function trackUpdateDialogDismissed(): void {
  analytics.track(VersionEvents.UPDATE_DIALOG_DISMISSED, {
    local_version: APP_BUILD_ID,
  })
}
